import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  Routes,
  Route,
  useMatch,
  useSearchParams,
} from "react-router-dom";

import {
  Tasks,
  TasksDetails,
  JobPlanList,
  JobPlanDetails,
  WorkOrderList,
  WorkOrderDetails,
  WorkOrderTaskDetails,
  PMList,
  PMform,
  CMList,
  CMDetails,
  EWOList,
  EWODetails,
  FieldDataMeasurementList,
  FieldDataMeasurementDetails,
  ItemDetails,
  ItemList,
  InspectionList,
  InspectionDetails,
  WorkFlowList,
  WorkFlowDetails,
  MaterialList,
  MaterialDetails,
  ToolsDetails,
  ToolsList,
  ManPowerList,
  ManPowerDetails,
  FailureCodeList,
  FailureCodeDetails,
  EquipmentDetails,
  EquipmentList,
  SRList,
  SRDetails,
  InspectionMasterList,
  InspectionMasterDetails,
  InspectionMaster,
  EquipmentTagList,
  EquipmentTagDetails,
  InventoryList,
  InventoryDetails,
  EquipmentOverviewList,
  EquipmentOverviewDetails,
  EAMLandingPage,
  Location,
  ELogScheduleList,
  ELogScheduleDetails,
} from "../pages";

const AMMRouter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const propsData = { location, navigate, params };

  const dynamicRouteRender = (routes) => {
    return (
      routes &&
      Array.isArray(routes) &&
      routes.map((route, index) => (
        <Route key={index} {...route} />
      ))
    );
  };
  
  let routes = [
    { "path": "/Tasks", "element": <Tasks {...propsData} /> },
    { "path": "/TasksDetails/:id", "element": <TasksDetails {...propsData} /> },
    { "path": "/JobPlanList", "element": <JobPlanList {...propsData} /> },
    { "path": "/JobPlanDetails/:id", "element": <JobPlanDetails {...propsData} /> },
    { "path": "/WorkOrderList", "element": <WorkOrderList {...propsData} /> },
    { "path": "/WorkOrderDetails/:id", "element": <WorkOrderDetails {...propsData} /> },
    { "path": "/WorkOrderTaskDetails/:id", "element": <WorkOrderTaskDetails {...propsData} /> },
    { "path": "/PMList", "element": <PMList {...propsData} /> },
    { "path": "/PreventiveMaintenanceDetails/:id", "element": <PMform {...propsData} /> },
    { "path": "/CMList", "element": <CMList {...propsData} /> },
    { "path": "/CMDetails/:id", "element": <CMDetails {...propsData} /> },
    { "path": "/EWOList", "element": <EWOList {...propsData} /> },
    { "path": "/EWODetails/:id", "element": <EWODetails {...propsData} /> },
    { "path": "/FieldDataMeasurementList", "element": <FieldDataMeasurementList {...propsData} /> },
    { "path": "/FieldDataMeasurementDetails/:id", "element": <FieldDataMeasurementDetails {...propsData} /> },
    { "path": "/ItemList", "element": <ItemList {...propsData} /> },
    { "path": "/ItemDetails/:id", "element": <ItemDetails {...propsData} /> },
    { "path": "/MaterialList", "element": <MaterialList {...propsData} /> },
    { "path": "/MaterialDetails/:id", "element": <MaterialDetails {...propsData} /> },
    { "path": "/ToolsList", "element": <ToolsList {...propsData} /> },
    { "path": "/ToolsDetails/:id", "element": <ToolsDetails {...propsData} /> },
    { "path": "/ManPowerList", "element": <ManPowerList {...propsData} /> },
    { "path": "/ManPowerDetails/:id", "element": <ManPowerDetails {...propsData} /> },
    { "path": "/InspectionList", "element": <InspectionList {...propsData} /> },
    { "path": "/InspectionDetails/:id", "element": <InspectionDetails {...propsData} /> },
    { "path": "/FailureCodeList", "element": <FailureCodeList {...propsData} /> },
    { "path": "/FailureCodeDetails/:id", "element": <FailureCodeDetails {...propsData} /> },
    { "path": "/EquipmentList", "element": <EquipmentList {...propsData} /> },
    { "path": "/EquipmentDetails/:id", "element": <EquipmentDetails {...propsData} /> },
    { "path": "/WorkFlowList", "element": <WorkFlowList {...propsData} /> },
    { "path": "/WorkFlowDetails/:id", "element": <WorkFlowDetails {...propsData} /> },
    { "path": "/SRList", "element": <SRList {...propsData} /> },
    { "path": "/SRDetails/:id", "element": <SRDetails {...propsData} /> },
    { "path": "/InspectionMasterList", "element": <InspectionMasterList {...propsData} /> },
    { "path": "/InspectionMasterDetails/:id", "element": <InspectionMasterDetails {...propsData} /> },
    { "path": "/InspectionMaster", "element": <InspectionMaster {...propsData} /> },
    { "path": "/EquipmentTagList", "element": <EquipmentTagList {...propsData} /> },
    { "path": "/EquipmentTagDetails/:id", "element": <EquipmentTagDetails {...propsData} /> },
    { "path": "/InventoryList", "element": <InventoryList {...propsData} /> },
    { "path": "/InventoryDetails/:id", "element": <InventoryDetails {...propsData} /> },
    { "path": "/EquipmentOverviewList", "element": <EquipmentOverviewList {...propsData} /> },
    { "path": "/EquipmentOverviewDetails/:id", "element": <EquipmentOverviewDetails {...propsData} /> },
    { "path": "/LandingPage", "element": <EAMLandingPage {...propsData} /> },
    { "path": "/ELogScheduleList", "element": <ELogScheduleList {...propsData} /> },
    { "path": "/ELogScheduleDetails/:id", "element": <ELogScheduleDetails {...propsData} /> },
    { "path": "/Locations", "element": <Location {...propsData} /> }
  ];

  return (
    <div>
      <Routes>{dynamicRouteRender(routes)}</Routes>
    </div>
  );
};

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    let searchParams = useSearchParams();
    let match = useMatch(location.pathname);
    let router = { location, navigate, params, match, searchParams };
    return (
      <Component
        {...props}
        {...router}
      />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter(AMMRouter);











